const swal = require("sweetalert");
module.exports.getStyledWelderName = function getStyledWelderName(value) {
  if (/90\s*ECO$/.test(value)) {
    return "<b class='zk_90_eco_text'>" + value + "</b>";
  } else if (/90\s*PRO$/.test(value)) {
    return "<b class='zk_90_pro_text'>" + value + "</b>";
  } else if (/(160\s*((PRO)|(ECO)))$/.test(value)) {
    return "<b  class='zk_160_pro_text'>" + value + "</b>";
  } else if (/PRO$/.test(value)) {
    return "<b class='general_zk_pro_text'>" + value + "</b>";
  } else if (/PRO$/.test(value)) {
    return "<b class='general_zk_pro_text'>" + value + "</b>";
  } else return "<b>" + value + "</b>";
};

//https://github.com/apvarun/toastify-js/blob/master/README.md
function ShowToastLabel(message, message_type) {
  let message_style;

  switch (message_type) {
    case "error":
      message_style = {
        background: "red",
        color: "white",
      };
      break;
    case "info":
      message_style = {
        background: "DodgerBlue",
        color: "white",
      };
      break;
    case "warning":
      message_style = {
        background: "Gold",
        color: "black",
      };
      break;
    case "success":
      message_style = {
        background: "LawnGreen",
        color: "black",
      };
      break;
    default:
      message_style = {};
  }

  let message_style_error = {
    background: "red",
    color: "white",
  };

  Toastify({
    text: message,
    duration: 6000,
    //   destination: "https://github.com/apvarun/toastify-js",
    newWindow: true,
    close: true,
    gravity: "bottom", // `top` or `bottom`
    position: "right", // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    style: message_style,
    onClick: function () {}, // Callback after click
  }).showToast();
}

function ShowToastMessage(message, type, stayTime, title) {
  //if (type==="success") 	ping.play();
  // else
  //if (type==="error") 	    errorPing.play();

  if (typeof title === "undefined") {
    title = "";
  }

  swal({
    title: title,
    text: message,
    timer: stayTime,
    icon: type.toLowerCase(),
    allowEscapeKey: true,
    allowOutsideClick: true,
    button: {
      text: "OK",
      value: true,
      visible: true,
      className: "",
      closeModal: true,
    },
  });
}

//parse a csv file to

module.exports.parseJsonToHTMLtable = function parseJsonToHTMLtable(
  table_title,
  json_data
) {
  let str;

  str = "<h5>" + table_title + "</h5><table>";
  Object.keys(json_data).forEach(function (key) {
    str +=
      "<tr><td><b>" +
      key +
      ":</b>&nbsp</td>><td>" +
      json_data[key] +
      "</td></tr>";
  });
  str += "</table>";

  return str;
};
module.exports.ShowToastMessage = ShowToastMessage;

module.exports.ShowAxiosApiErrorMessage = function ShowAxiosApiErrorMessage(
  response_object
) {
  let message;

  function getMakeAndShowErrorMessage() {
    message =
      "getWelderOptions error: nr:" +
      response_object.response.data.error.code +
      ", message:" +
      response_object.response.data.error.message;

    ShowToastLabel(message, "error");
  }

  console.log(response_object); //todo obsługa błedów

  if (
    "response" in response_object &&
    "data" in response_object.response &&
    Array.isArray(response_object.response.data) &&
    "error" in response_object.response.data
  ) {
    getMakeAndShowErrorMessage();
  }
  if (
    "response" in response_object &&
    "data" in response_object.response &&
    "error" in response_object.response.data
  ) {
    getMakeAndShowErrorMessage();
  } else {
    message =
      "AXIOS failed with message: '" +
      response_object.message +
      " ." +
      HTTPcodeToMessage(response_object.response.status);

    ShowToastLabel(message, "error");

    console.log(message); //todo obsługa błedów
  }

  // ShowToastMessage(message, "error");
};

module.exports.HTTPcodeToMessage = HTTPcodeToMessage;
function HTTPcodeToMessage(code) {
  let Messages = {
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    306: "Unused",
    307: "Temporary Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Required",
    413: "Request Entry Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    429: "Too Many Requests",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported",
  };

  return Messages[code];
}
